/** @jsxImportSource @emotion/react */

import css from '@emotion/css/macro'
import type { Action } from '../stepsController'
import colors from '@sportninja/common/constants/appColors'

export interface StepProps {
  stepDispatcher: React.Dispatch<Action>
}

export const UserSelection = ({ stepDispatcher }: StepProps) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        onClick={() => stepDispatcher({ type: 'set', payload: 1 })}
        css={css`
          cursor: pointer;
          padding: 42px 0;
          background-color: ${colors.DEFAULT_FLAIR};
          align-items: center;
          justify-content: center;
          display: flex;
          gap: 8px;
          border-radius: 8px;
          flex-direction: column;
          transition: all 0.4s ease-in-out;

          &:hover {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
          }
        `}
      >
        <p
          css={css`
            font-size: 24px;
            font-weight: 700;
            text-align: center;
            color: ${colors.HEADER_BG_2};
          `}
        >
          Sign up as Member
        </p>
        <p
          css={css`
            font-size: 14px;
            font-weight: 500;
            text-align: center;
            color: ${colors.HEADER_BG_2};
          `}
        >
          (Player, Team Rep, Official, Admin, Parent/Guardian)
        </p>
      </div>

      <div
        onClick={() => stepDispatcher({ type: 'set', payload: 2 })}
        css={css`
          cursor: pointer;
          margin-top: 32px;
          padding: 42px 0;
          border: 2px solid ${colors.DEFAULT_FLAIR};
          background-color: transparent;
          align-items: center;
          justify-content: center;
          display: flex;
          gap: 8px;
          border-radius: 8px;
          flex-direction: column;
          transition: all 0.4s ease-in-out;

          &:hover {
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
          }
        `}
      >
        <p
          css={css`
            font-size: 24px;
            font-weight: 700;
            text-align: center;
            color: ${colors.WHITE};
          `}
        >
          Create League/Org Account
        </p>
        <p
          css={css`
            font-size: 14px;
            font-weight: 500;
            text-align: center;
            color: ${colors.WHITE};
          `}
        >
          (League Owners, League Administrators)
        </p>
      </div>
    </div>
  )
}
